import React from 'react';
import { Box } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

import { wsrColors, wsrShadow } from './wsrTokens';

interface WsrPageHeaderProps {
  start: string;
  end: string;
  onStart: (value: string) => void;
  onEnd: (value: string) => void;
}

const dateInputSx = {
  border: 'none',
  outline: 'none',
  fontSize: 13,
  fontFamily: 'inherit',
  color: wsrColors.slate800,
  fontWeight: 500,
  padding: 0,
  background: 'transparent',
};

const DateField: React.FC<{
  label: string;
  value: string;
  onChange: (v: string) => void;
}> = ({ label, value, onChange }) => (
  <Box component="label" sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
    <Box
      component="span"
      sx={{
        fontSize: 11,
        color: wsrColors.slate400,
        textTransform: 'uppercase',
        letterSpacing: '.06em',
      }}
    >
      {label}
    </Box>
    <Box
      component="input"
      type="date"
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      sx={dateInputSx}
    />
  </Box>
);

const WsrPageHeader: React.FC<WsrPageHeaderProps> = ({ start, end, onStart, onEnd }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '16px',
    }}
  >
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <AutoAwesomeIcon sx={{ fontSize: 28, color: wsrColors.slate800 }} />
        <Box
          component="h1"
          sx={{ margin: 0, fontSize: 30, fontWeight: 700, letterSpacing: '-0.02em' }}
        >
          WSR Report
        </Box>
      </Box>
      <Box sx={{ marginTop: '6px', color: wsrColors.slate500, fontSize: 14 }}>
        Weekly Status Report — service desk, tickets, and operational health
      </Box>
    </Box>

    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        background: '#fff',
        border: `1px solid ${wsrColors.slate200}`,
        borderRadius: '10px',
        padding: '10px 14px',
        boxShadow: wsrShadow,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: wsrColors.slate500,
          fontSize: 13,
          fontWeight: 500,
        }}
      >
        <CalendarMonthOutlinedIcon sx={{ fontSize: 16 }} />
        Date range
      </Box>
      <DateField label="Start" value={start} onChange={onStart} />
      <Box sx={{ color: wsrColors.slate300 }}>→</Box>
      <DateField label="End" value={end} onChange={onEnd} />
    </Box>
  </Box>
);

export default WsrPageHeader;
